<template>
  <div id="printPackingList">
    <printer title="Packing List">
      <template v-slot:printContent>
        <div
          v-for="li in listItems"
          :key="li.Id"
        >
          <h6>{{ li.Description }}</h6>
          <ul>
            <li
              v-for="pli in li.PackingListItems"
              :key="pli.Id"
            >
              {{ pli.Description }}
            </li>
          </ul>
        </div>
      </template>
    </printer>
  </div>
</template>

<script>
import Printer from '@/components/_main/printer.vue'

export default {
  name: 'PackingListPrint',
  components: {
    Printer
  },
  props: {
    listItems: {
      type: Array,
      default: function () {
        return []
      }
    },
    showPrint: {
      type: Boolean,
      default: undefined
    }
  }
}
</script>
